import useSWR from "swr";
import { api, fetcher } from "@/shared/api/http";

export type TipoNotificacao =
  | "reserva_nova"
  | "reserva_confirmada"
  | "reserva_parcial"
  | "reserva_recusada"
  | "comissao_paga"
  | "estoque_importado"
  | "estoque_pausado"
  | "estoque_retomado"
  | "carta_desativada"
  | "carta_ativada"
  | "parceiro_primeiro_acesso"
  | "parceiro_conta_excluida";

export interface Notificacao {
  id: string;
  tipo: TipoNotificacao;
  titulo: string;
  texto: string;
  link: string | null;
  criadaEm: string;
  lida: boolean;
}

interface ListaNotificacoes {
  itens: Notificacao[];
  naoLidas: number;
  temMais: boolean;
}

export const CHAVE_NOTIFICACOES = "/notificacoes?limite=20";

/** Sino do topo: revalida a cada 30 s e ao voltar para a aba (padrão do SWR). */
export function useNotificacoes() {
  return useSWR<ListaNotificacoes>(CHAVE_NOTIFICACOES, fetcher, { refreshInterval: 30_000, keepPreviousData: true });
}

/** Contador do sino: as não lidas dos últimos 30 dias (badge do topo). */
export function useNotificacoesNaoLidas(): number {
  return useNotificacoes().data?.naoLidas ?? 0;
}

export const notificacoesApi = {
  marcarLida: (id: string) => api<void>(`/notificacoes/${id}/lida`, { method: "POST" }),
  marcarTodas: () => api<void>("/notificacoes/lidas", { method: "POST" }),
};
